/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { useTheme } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { CreateNoteButton } from '@/components/buttons/viewHeaderButtons/CreateNoteButton';
import { CreateTaskButton } from '@/components/buttons/viewHeaderButtons/CreateTaskButton';
import { TabView } from '@/components/layouts/TabView';
import { getDebtorTabs } from 'app/tabs';
import { getPipelineIcon } from '@/utils/constants';
import { EditPolicyTransactionButton } from '@/components/buttons/viewHeaderButtons/EditPolicyTransactionsButton';

const HEADER_COMPONENTS = {
	notes: CreateNoteButton,
	tasks: CreateTaskButton,
	'': EditPolicyTransactionButton,
};

export const DebtorTabView = () => {
	const theme = useTheme();

	const { dealRow } = useObjectContext();

	const pipelineId = dealRow?.pipeline;

	return (
		<TabView
			objectType='debtor'
			getTabs={getDebtorTabs}
			headerComponents={HEADER_COMPONENTS}
			icon={getPipelineIcon(
				pipelineId,
				'55px',
				theme.palette.mode === 'dark' ? { bgColor: 'transparent' } : undefined,
			)}
		/>
	);
};
